module.exports = __webpack_public_path__ + "static/img/kirabira.e6681cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beads/kirabira.jpg
// module id = 68
// module chunks = 1